import { createContext } from "react";

interface ConfirmOptions {
    title: string;
    description: string;
    onConfirm?: () => Promise<void>;
    onCancel?: () => Promise<void>;
    dismissable?: boolean;
    color?:
        | "danger"
        | "warning"
        | "success"
        | "default"
        | "primary"
        | "secondary";
    confirmText?: string;
    cancelText?: string;
}

interface ConfirmContextType {
    showConfirm: (options: ConfirmOptions) => void;
}

const ConfirmContext = createContext<ConfirmContextType | undefined>(undefined);

export default ConfirmContext;
export type { ConfirmOptions, ConfirmContextType };
